import React from 'react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

// 文件夹图标组件
export const FolderIcon: React.FC<IconProps> = ({ className = '', style = {} }) => {
  return (
    <img
      src="/icons/folder-icon.svg"
      alt="文件夹"
      className={`inline-block align-middle ${className}`}
      style={{ 
        width: '22px', 
        height: '22px', 
        marginRight: '4px',
        verticalAlign: 'middle',
        ...style 
      }}
    />
  );
};

// 本体图标组件
export const OntologyIcon: React.FC<IconProps> = ({ className = '', style = {} }) => {
  return (
    <img
      src="/icons/ontology-icon.svg"
      alt="本体"
      className={`inline-block align-middle ${className}`}
      style={{ 
        width: '22px', 
        height: '22px', 
        marginRight: '4px',
        verticalAlign: 'middle',
        ...style 
      }}
    />
  );
};